import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueToastify from "vue-toastify";
import Vuex from 'vuex'

Vue.config.productionTip = false
const SSC = require('sscjs')
let ssc = new SSC('https://engine.rishipanthee.com/')
Vue.prototype.$ssc = ssc;

Vue.use(Vuex);
//
// // Move this to it's own structured directory if we start using this more
const store = new Vuex.Store({
  state: {
    selectedTable: { symbol: 'STAR', fullName: 'Rising Star' },
    user: ""
  },
  mutations: {
    changeTable(state, newTable) {
      state.selectedTable = newTable;
    },
    changeUser(state, user) {
      state.user = user;
    }
  }
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueToastify, {
  position: "top-right",
  canTimeout: true,
  duration: 3000,
  theme: "light",
  iconEnabled: false,
});